import {
  useMemberInvitations,
  useNetwork,
  useNetworkRoles,
} from '@tribeplatform/react-sdk/hooks'

export const useSeatsCapacity = () => {
  const roles = useNetworkRoles()
  const { data: network } = useNetwork()

  const { data: adminInvitations } = useMemberInvitations({
    fields: 'basic',
    variables: {
      limit: 0,
      roleIds: [roles?.admin?.id],
    },
  })

  const { data: moderatorInvitations } = useMemberInvitations({
    fields: 'basic',
    variables: {
      limit: 0,
      roleIds: [roles?.moderator?.id],
    },
  })

  const adminInvitationCount = adminInvitations?.pages?.[0]?.totalCount ?? 0
  const moderatorInvitationCount =
    moderatorInvitations?.pages?.[0]?.totalCount ?? 0
  const seatsUsed =
    moderatorInvitationCount +
    adminInvitationCount +
    (network?.seatCapacityDeclared ?? 0)

  return {
    adminInvitationCount,
    moderatorInvitationCount,
    seatsCapacity: network?.seatsCapacity,
    seatsCapacityDeclared: network?.seatCapacityDeclared,
    seatsUsed,
    didReachLimit: seatsUsed >= (network?.seatsCapacity ?? 0),
  }
}
